import { render, staticRenderFns } from "./formBody.vue?vue&type=template&id=428ee070&scoped=true"
import script from "./formBody.vue?vue&type=script&lang=js"
export * from "./formBody.vue?vue&type=script&lang=js"
import style0 from "./formBody.vue?vue&type=style&index=0&id=428ee070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428ee070",
  null
  
)

export default component.exports